<template>
	<div class="tabs">
		<div @click="tab(index)" v-for="(item,index) in tabs" :key="index" class="item"
			:class="index == curIndex? 'active-item':''">
			<span class="title"> {{ item.title }} </span>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Tabs',
		props: {
			tabs: Array,
			cur: {
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				curIndex: 0
			};
		},

		created() {
			this.curIndex = this.cur
		},
		methods: {
			tab(index) {
				this.curIndex = index
				this.$emit('changeTab', index)
			}

		}
	}
</script>

<style scoped lang="scss">
	.tabs {
		height: 50px;
		background: #FFFFFF;
		display: flex;
		.item {
			
			width: 102px;
			font-size: 15px;
			height: 50px;
			line-height: 50px;
			font-weight: 400;
			color: #666666;
			cursor: pointer;
			text-align: center;
			&.active-item {
				font-size: 16px;
				font-weight: bold;
				color: #0F114A;
				border-bottom: 3px solid #0F114A;
			}
		}


	}
</style>
